export function myAppInitializer(): () => void {

  return () => {}

}
